import { GridListTile } from 'pages/Registration/ResponsiveGridList';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles, Theme } from '@material-ui/core';
import reasonOnlyRegisterImage from 'static/img/registrations.png';

const teal5 = '#f4fafa';

interface ReasonOnlyTile {
  onSelectReasonOnlyRegistration: () => void;
}

const ReasonOnlyTile: React.FunctionComponent<ReasonOnlyTile> = (props) => {
  const classes = styles(props);
  const intl = useIntl();
  const { onSelectReasonOnlyRegistration, ...styleProps } = props;

  return (
    <GridListTile
      {...styleProps}
      name={intl.formatMessage({ id: 'addNewReasonRegistration' })}
      image={reasonOnlyRegisterImage}
      value={intl.formatMessage({ id: 'addNewReasonRegistration' })}
      onClick={onSelectReasonOnlyRegistration}
      isSelected={true}
      className={classes.tile}
    />
  );
};

const styles = makeStyles<Theme, ReasonOnlyTile>({
  tile: {
    '& > *': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: teal5,
      padding: '20px 20px 50px 20px'
    },
    '& img': {
      position: 'static',
      transform: 'none',
      paddingTop: '20px',
      width: '120% !important',
      height: 'auto !important'
    }
  }
});

export default ReasonOnlyTile;
